import { Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { ApplicantForm } from '../../../common/applicant-data-section/forms/applicant.form';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../general-letter.routes';
import { ApplicationCommonComponent } from '../../../common/application.common.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  ProxyFormComponent
} from '../../../common/applicant-data-section/components/proxy-person-form/proxy-form.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { SessionService } from '../../../../../../services/ssession.service';
import { UserDetails } from '../../../../../../store/reducers/user-details.reducer';
import { selectUser } from '../../../../../../store/selectors/user-details.selectors';
import { updateApplicantData } from '../../../../../../store/actions/application.actions';
import { NgxMaskDirective } from 'ngx-mask';
import {
  ApplicantAddressDataFormComponent
} from '../../../common/applicant-data-section/components/applicant-address-data-form/applicant-address-data-form.component';
import { RouterLink } from '@angular/router';
import { EntityType } from '../../../../../../pipes/entity-type.pipe';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-general-letter-applicant-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ProxyFormComponent,
    ValidationErrorsComponent,
    NgxMaskDirective,
    ApplicantAddressDataFormComponent,
    RouterLink
  ],
  providers: [ApplicantForm],
  templateUrl: './general-letter-applicant-data-section.component.html'
})
export class GeneralLetterApplicantDataSectionComponent extends ApplicationCommonComponent implements OnInit, OnDestroy {

  public stages: string[] = stages;

  public form: ApplicantForm = inject(ApplicantForm);

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  private fetchApplicant = toObservable(this.application).subscribe((data) => {
    this.form.patchFormValues(data);
  });

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplicantData({
        application: this.application() || {},
        applicationPayload: {
          isFiledByProxy: this.form.isFiledByProxy.value,
          ...this.form.proxyPersonForm?.toWriteModel()
        },
        applicantPayload: this.form.toWriteModel(),
        successFnc: (applicationId) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public override ngOnInit() {
    super.ngOnInit();
    this.form?.entityType?.setValue(EntityType.OSOBA_FIZYCZNA);
    this.form.identifierType.setValue('PESEL');
    this.form?.nip.disable();
    this.form?.regon.disable();
    this.form?.name.disable();

    this.form?.fatherName.disable();
    this.form?.motherName.disable();
    this.form?.birthDate.disable();

    this.form?.firstName.enable();
    this.form?.lastName.enable();
    this.form?.pesel.enable();
  }

  public override ngOnDestroy() {
    super.ngOnDestroy();
    this.fetchApplicant.unsubscribe();
  }
}
